import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/footer";
import { IMAGES } from "../../constant/Image";
import Banner from "../../components/TitleBanner/index";
import { Link } from "react-router-dom";
import { cardData, categoryData } from "../../constant/fake-data";
import Button from "../../components/Button/index";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/index";
import Slider from "react-slick";
import AuctionSlider from "../../components/Auction_Card";

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow next" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="15"
        viewBox="0 0 9 15"
        fill="none"
      >
        <path
          d="M9 7.50009L0 0L5.72727 7.50009L0 15L9 7.50009Z"
          fill="#0B0C0C"
        />
      </svg>
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow prev" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="15"
        viewBox="0 0 9 15"
        fill="none"
      >
        <path
          d="M0 7.49991L9 15L3.27273 7.49991L9 0L0 7.49991Z"
          fill="#0B0C0C"
        />
      </svg>
    </div>
  );
};

// Auction Slider Settings
const auctionSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

const SellWithUs = () => {
  return (
    <div>
      <Header />

      <Banner
        title="Sell With Us"
        bgImage={IMAGES.SellWithUsBannerBg}
        breadcrumbs={["Sell With Us"]}
      />

      <section className="sell-with-tabs-sec">
        <div className="container-fluid p-0">
          <div className="row">
            <div className="col-md-12">
              {/* Bootstrap Tabs */}
              <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="cars-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#cars"
                    type="button"
                    role="tab"
                  >
                    Cars
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="plates-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#plates"
                    type="button"
                    role="tab"
                  >
                    Plates & Automobilia
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="sealed-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#sealed"
                    type="button"
                    role="tab"
                  >
                    Sealed Bids
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="offmarket-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#offmarket"
                    type="button"
                    role="tab"
                  >
                    Off-Market Sales
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="managed-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#managed"
                    type="button"
                    role="tab"
                  >
                    Managed Service
                  </button>
                </li>
              </ul>

              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="cars"
                  role="tabpanel"
                  aria-labelledby="cars-tab"
                >
                  <div className="content-video-box">
                    <div className="content-box">
                      <div className="text">
                        <h6>Cars</h6>
                      </div>
                      <div className="text-box">
                        <h5>No seller fees</h5>
                        <p>
                          We don’t charge you to list, and we don’t deduct
                          anything from the hammer price.
                        </p>
                      </div>

                      <div className="text-box">
                        <h5>Sell with confidence</h5>
                        <p>
                          You can set a reserve price that balances peace of
                          mind with encouraging bids.
                        </p>
                      </div>

                      <div className="text-box">
                        <h5>Maximise your sale</h5>
                        <p>
                          We’ll share our expertise on how you can achieve a
                          great result in a 7-day auction.
                        </p>
                      </div>

                      <Button
                        text="Submit your Vehicle"
                        primary={true}
                        icon={false}
                        onClick={() => console.log("View All Auctions clicked")}
                        style={{ fill: "black" }}
                      />
                    </div>
                    <div className="video-box">
                      <iframe
                        width="1250"
                        height="703"
                        src="https://www.youtube.com/embed/tUjIwYeVlQc"
                        title="BMW M3 G80 | CAP CUT | CAR EDIT | 4K"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="plates"
                  role="tabpanel"
                  aria-labelledby="plates-tab"
                >
                  <div className="content-video-box">
                    <div className="content-box">
                      <div className="text">
                        <h6>Cars</h6>
                      </div>
                      <div className="text-box">
                        <h5>No seller fees</h5>
                        <p>
                          We don’t charge you to list, and we don’t deduct
                          anything from the hammer price.
                        </p>
                      </div>

                      <div className="text-box">
                        <h5>Sell with confidence</h5>
                        <p>
                          You can set a reserve price that balances peace of
                          mind with encouraging bids.
                        </p>
                      </div>

                      <div className="text-box">
                        <h5>Maximise your sale</h5>
                        <p>
                          We’ll share our expertise on how you can achieve a
                          great result in a 7-day auction.
                        </p>
                      </div>

                      <Button
                        text="Submit your Vehicle"
                        primary={true}
                        icon={false}
                        onClick={() => console.log("View All Auctions clicked")}
                        style={{ fill: "black" }}
                      />
                    </div>
                    <div className="video-box">
                      <iframe
                        width="1250"
                        height="703"
                        src="https://www.youtube.com/embed/tUjIwYeVlQc"
                        title="BMW M3 G80 | CAP CUT | CAR EDIT | 4K"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="sealed"
                  role="tabpanel"
                  aria-labelledby="sealed-tab"
                >
                  <div className="content-video-box">
                    <div className="content-box">
                      <div className="text">
                        <h6>Cars</h6>
                      </div>
                      <div className="text-box">
                        <h5>No seller fees</h5>
                        <p>
                          We don’t charge you to list, and we don’t deduct
                          anything from the hammer price.
                        </p>
                      </div>

                      <div className="text-box">
                        <h5>Sell with confidence</h5>
                        <p>
                          You can set a reserve price that balances peace of
                          mind with encouraging bids.
                        </p>
                      </div>

                      <div className="text-box">
                        <h5>Maximise your sale</h5>
                        <p>
                          We’ll share our expertise on how you can achieve a
                          great result in a 7-day auction.
                        </p>
                      </div>

                      <Button
                        text="Submit your Vehicle"
                        primary={true}
                        icon={false}
                        onClick={() => console.log("View All Auctions clicked")}
                        style={{ fill: "black" }}
                      />
                    </div>
                    <div className="video-box">
                      <iframe
                        width="1250"
                        height="703"
                        src="https://www.youtube.com/embed/tUjIwYeVlQc"
                        title="BMW M3 G80 | CAP CUT | CAR EDIT | 4K"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="offmarket"
                  role="tabpanel"
                  aria-labelledby="offmarket-tab"
                >
                  <div className="content-video-box">
                    <div className="content-box">
                      <div className="text">
                        <h6>Cars</h6>
                      </div>
                      <div className="text-box">
                        <h5>No seller fees</h5>
                        <p>
                          We don’t charge you to list, and we don’t deduct
                          anything from the hammer price.
                        </p>
                      </div>

                      <div className="text-box">
                        <h5>Sell with confidence</h5>
                        <p>
                          You can set a reserve price that balances peace of
                          mind with encouraging bids.
                        </p>
                      </div>

                      <div className="text-box">
                        <h5>Maximise your sale</h5>
                        <p>
                          We’ll share our expertise on how you can achieve a
                          great result in a 7-day auction.
                        </p>
                      </div>

                      <Button
                        text="Submit your Vehicle"
                        primary={true}
                        icon={false}
                        onClick={() => console.log("View All Auctions clicked")}
                        style={{ fill: "black" }}
                      />
                    </div>
                    <div className="video-box">
                      <iframe
                        width="1250"
                        height="703"
                        src="https://www.youtube.com/embed/tUjIwYeVlQc"
                        title="BMW M3 G80 | CAP CUT | CAR EDIT | 4K"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="managed"
                  role="tabpanel"
                  aria-labelledby="managed-tab"
                >
                  <div className="content-video-box">
                    <div className="content-box">
                      <div className="text">
                        <h6>Cars</h6>
                      </div>
                      <div className="text-box">
                        <h5>No seller fees</h5>
                        <p>
                          We don’t charge you to list, and we don’t deduct
                          anything from the hammer price.
                        </p>
                      </div>

                      <div className="text-box">
                        <h5>Sell with confidence</h5>
                        <p>
                          You can set a reserve price that balances peace of
                          mind with encouraging bids.
                        </p>
                      </div>

                      <div className="text-box">
                        <h5>Maximise your sale</h5>
                        <p>
                          We’ll share our expertise on how you can achieve a
                          great result in a 7-day auction.
                        </p>
                      </div>

                      <Button
                        text="Submit your Vehicle"
                        primary={true}
                        icon={false}
                        onClick={() => console.log("View All Auctions clicked")}
                        style={{ fill: "black" }}
                      />
                    </div>
                    <div className="video-box">
                      <iframe
                        width="1250"
                        height="703"
                        src="https://www.youtube.com/embed/tUjIwYeVlQc"
                        title="BMW M3 G80 | CAP CUT | CAR EDIT | 4K"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Bootstrap Tabs */}
            </div>
          </div>
        </div>
      </section>

      <section className="upcoming-auction latest-auction ongoing-auction recently-sold">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text">
                <div className="bottom-line bottom-line-non">
                  <h2>
                    Recently <span>Sold</span>
                  </h2>
                </div>
              </div>
              <Slider {...auctionSettings}>
                {cardData.map((val) => (
                  <AuctionSlider item={val} key={val.id} />
                ))}
              </Slider>

              <div className="t-btn-center">
                <Button
                  text="View All Auctions"
                  primary={true}
                  icon={true}
                  onClick={() => console.log("View All Auctions clicked")}
                  style={{ fill: "black" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="HowItWorks-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text">
                <h2>How it works</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="img-box">
                <img src={IMAGES.HotItWorks_Img_01} alt="" />
                <div className="text">
                  <h5>Submit your vehicle</h5>
                  <p>
                    We aim to call you within 2 hours to discuss your enquiry
                    and find out some more details.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="img-box">
                <img src={IMAGES.HotItWorks_Img_02} alt="" />
                <div className="text">
                  <h5>Photos and description</h5>
                  <p>
                    We’ll connect you with a pro photographer who can capture 100+ high-quality images, and we’ll work with you on a detailed description.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="img-box">
                <img src={IMAGES.HotItWorks_Img_03} alt="" />
                <div className="text">
                  <h5>Go live</h5>
                  <p>
                    Once you’re ready, we’ll get your vehicle live for bids, marketing it to our global community of enthusiasts and beyond, to find the perfect buyer.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FrequentlyAskedQuestions />

      <Footer />
    </div>
  );
};

export default SellWithUs;
